import { NavigationActionTypes, TNavigationActions } from './actions';

interface INavigationState {
  currentRoute: string;
  fbManagerPageAccess: boolean;
  sidebarMenuCollapsed: boolean;
}

const initialState: INavigationState = {
  currentRoute: '/me',
  fbManagerPageAccess: true,
  sidebarMenuCollapsed: false,
};

export const navigationReducer = (state = initialState, action: TNavigationActions): INavigationState => {
  switch (action.type) {
    case NavigationActionTypes.SET_CURRENT_ROUTE:
      return { ...state, currentRoute: action.payload };
    case NavigationActionTypes.SET_FBMANAGER_PAGE_ACCESS:
      return { ...state, fbManagerPageAccess: action.payload };
    case NavigationActionTypes.MAIN_MENU_COLLAPSED:
      return { ...state, sidebarMenuCollapsed: action.payload };
    default:
      return state;
  }
};
